var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_2_",
    "data-name": "search (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36421",
    "data-name": "Path 36421",
    d: "M5.762,146.959l-.905,3.379-3.308.07a13.023,13.023,0,0,1-.1-12.139h0l2.945.54,1.29,2.927a7.758,7.758,0,0,0,.073,5.224Z",
    transform: "translate(0 -131.247)",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36422",
    "data-name": "Path 36422",
    d: "M274.115,208.176a12.995,12.995,0,0,1-4.634,12.566h0l-3.709-.189-.525-3.277a7.748,7.748,0,0,0,3.334-3.956h-6.951v-5.143h12.487Z",
    transform: "translate(-248.342 -197.605)",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36423",
    "data-name": "Path 36423",
    d: "M50.1,316.834h0a13,13,0,0,1-19.589-3.977l4.213-3.449a7.732,7.732,0,0,0,11.141,3.959Z",
    transform: "translate(-28.96 -293.697)",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36424",
    "data-name": "Path 36424",
    d: "M48.468,2.993,44.257,6.441a7.731,7.731,0,0,0-11.4,4.048L28.625,7.021h0A13,13,0,0,1,48.468,2.993Z",
    transform: "translate(-27.17)",
    fill: "#f14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.706a1217049ec8b96622e8c08f786a86.svg";
export { ForwardRef as ReactComponent };